import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { useOffering } from '@/hooks/api/useOfferings'
import { Paths } from '@/routes/paths'
import { useNavigate } from '@tanstack/react-router'
import { ArrowLeft, Loader2, DollarSign } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { OfferingPriceForm } from '../../components/features/offerings/OfferingPriceForm'
import { NavHeader } from '@/components/features/shared/NavHeader'
import { PageContainer } from '@/components/features/shared/PageContainer'

interface AddOfferingPricePageProps {
  offeringId: string
}

export const AddOfferingPricePage = ({ offeringId }: AddOfferingPricePageProps) => {
  const { data: offering, isLoading } = useOffering(offeringId)
  const navigate = useNavigate()

  const handleBack = () => {
    navigate({ to: Paths.Management.Offerings + '/$offeringId', params: { offeringId } })
  }

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-[400px]">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    )
  }

  if (!offering) {
    return (
      <div className="p-8 text-center">
        <h2 className="text-xl font-semibold">Servicio no encontrado</h2>
        <Button variant="link" onClick={handleBack}>Volver</Button>
      </div>
    )
  }

  return (
    <PageContainer>
      <NavHeader>
        <div className="flex flex-col items-start gap-2">
          <h1 className="text-2xl font-bold tracking-tight">Agregar Nuevo Precio</h1>
          <p className="text-muted-foreground">
            Configura el precio por cada rango de edad para el servicio <span className="font-semibold text-foreground">{offering.name}</span>
          </p>
        </div>
      </NavHeader>

      <Card className="border-t-4 border-t-primary shadow-lg">
        <CardHeader className="bg-muted/30 pb-4">
          <div className="flex items-center gap-3">
            {/* <div className="p-2 bg-primary/10 rounded-full text-primary">
              <DollarSign className="h-5 w-5" />
            </div> */}
            <CardTitle className="text-xl">Detalle de precio por edad</CardTitle>
          </div>
        </CardHeader>
        <CardContent className="pt-4">
          <OfferingPriceForm
            offeringId={offeringId}
            currency={offering.currency}
            hasAgePricing={offering.hasAgePricing}
            onSuccess={handleBack}
            onCancel={handleBack}
          />
        </CardContent>
      </Card>
    </PageContainer>
  )
}
